"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default =

function () {
    "ngInject";
    return function (text) {
        return stripHtml(text);
    };
};

var stripHtml = function () {
    var tmpEl = document.createElement("DIV");
    function strip(html) {
        if (!html) {
            return "";
        }
        tmpEl.innerHTML = html;
        return tmpEl.textContent || tmpEl.innerText || "";
    }
    return strip;
}();

;


//////////////////
// WEBPACK FOOTER
// ./app/base/filters/plain.js
// module id = 14
// module chunks = 0